import React, { PropTypes, PureComponent } from 'react';
import _ from 'underscore';

export default class DelayedChangeInput extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    delay: PropTypes.number
  };

  static defaultProps = {
    delay: 300
  };

  state = {
    value: this.props.value
  };

  componentWillReceiveProps({ value, delay }) {
    if (value !== this.props.value) {
      this.setState({ value });
    }

    if (delay !== this.props.delay) {
      this.debouncedTriggerChange = _.debounce(this.triggerChange, delay);
    }
  }

  triggerChange = () => {
    const { value, onChange } = this.props;
    const { value: typing } = this.state;

    if (typing !== value) {
      onChange(typing);
    }
  };

  focus = () => this.refs.input.focus();

  debouncedTriggerChange = _.debounce(this.triggerChange, this.props.delay);

  handleChange = e => this.setState({ value: e.target.value }, this.debouncedTriggerChange);

  render() {
    const { value, onChange, delay, ...rest } = this.props;
    const { value: typing } = this.state;

    return (
      <input {...rest} ref="input" value={typing} onChange={this.handleChange}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/inputs/DelayedChangeInput.jsx